import { Link } from "react-router-dom";
import { SERVICES } from "../../constants";
import { PREV_IMG } from "../../constants/endPoints";
import { convertToBase64, hasYear, optText } from "../../constants/helper";

const ProductListServiceItem = ({ val, i, loc, ...props }) => {
    const manuName = optText(val.manufacturer_id == -1 ? val.manufacturer_name : (val.manufacturer && val.manufacturer.name));
    const modelName = optText(val.model_id == -1 ? val.model_name : (val.model && val.model.name));
    const vehicleTitle = [manuName, modelName, hasYear(val.year) ? val.year : ''].filter(Boolean).join(' ');
    return (
        <div className="sectls" key={i}>
            <Link to={"/product_details/" + convertToBase64(val.id)} className="sectls-img">
                <img src={PREV_IMG + val.default_photo.img_path} onError={(e) => { e.target.src = "/assets/images/placeholder.jpeg" }} />
            </Link>
            <div className="sectls-cont">
                <div className="sectls-ttl-wrap">
                    {/* Check if there is menufecturer then show manufacturer as title else show title */}
                    {
                        manuName &&
                        <h3><Link to={"/product_details/" + convertToBase64(val.id)}>
                            {vehicleTitle}
                            &nbsp;
                            Serviço
                        </Link></h3>
                    }
                    {
                        !manuName &&
                        <h3><Link to={"/product_details/" + convertToBase64(val.id)}>{val.title}
                            &nbsp;Serviço</Link></h3>
                    }
                </div>
                {
                    optText(val.description) &&
                    <div className="sectls-rating-wrap">
                        <p className="sectls-rating">
                            Descrição
                        </p>
                        <p className="uploaded_txt">{val.description}</p>&nbsp;&nbsp;
                    </div>
                }
            </div>

            <div className="sectls-info">
                {optText(val.service_area) && <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Área de serviço
                    </p>
                    <p className="uploaded_txt">{val.service_area}</p>
                </div>}

                {val.services && val.services.length > 0 && <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Serviços
                    </p>
                    <ul className="service-tags ps-0">
                        {val.services.map((service, i2) => (
                            <li className="service-tag" key={"service-tag-" + i2}>{service.service_name}</li>
                        ))}
                    </ul>
                </div>}

               {loc && loc.name && <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Província
                    </p>
                    <p className="uploaded_txt">{loc.name}</p>
                </div>}

                <div className="sectls-rating-wrap">
                    <p className="sectls-rating">
                        Carregado
                    </p>
                    <p className="uploaded_txt">{val.added_date_str}</p>
                </div>
            </div>
        </div>
    );
}

export default ProductListServiceItem;